import { set } from "mobx";
import React, { useState } from "react";
import { AiOutlineDownload } from "react-icons/ai";
import { apiPostPut } from "../../../api/api_methods";

const ExportDataUI3 = ({
  resumes = [],
  onExport,

  onSelectScoreRange,
  selectedAssessment,
  onSelectAssessment,
  isModalOpen,
  onClose,
}) => {
  const [selectedDateRange, onSelectDateRange] = useState("");
  const [selectedResumes, onSelectResumes] = useState("");
  const [isCustomDate, setIsCustomDate] = useState(false);
  const [isCustomScore, setIsCustomScore] = useState(false);
  const [isCustomExperince, setIsCustomExperince] = useState(false);
  const [selectedResume, setSelectedResume] = useState("");
  // const [assessmentType, setAssessmentType] = useState("all");
  const [statusFilter, setStatusFilter] = useState(null);
  const [minScore, setMinScore] = useState(0);
  const [maxScore, setMaxScore] = useState(100);
  const [startDate, setStartDate] = useState(null);
  const currentDate = new Date().getTime();
  const [endDate, setEndDate] = useState(currentDate);

  const [currentTab, setCurrentTab] = useState(-1);
  const [selectedExport, setSelectedExport] = useState();
  const ExportFormat = [
    { name: "Pdf", action: () => setCurrentTab(0), id: 0 },
    { name: "Xls", action: () => setCurrentTab(1), id: 1 },
    { name: "Csv", action: () => setCurrentTab(2), id: 2 },
    { name: "Json", action: () => setCurrentTab(3), id: 3 },
  ];
  console.log(ExportFormat);

  const handleDateRangeChange = (e) => {
    const value = e.target.value;

    if (value === "custom") {
      setIsCustomDate(true);
    } else if (value === "lastWeek") {
      // getting the date of last week
      const lastWeek = currentDate - 7 * 24 * 60 * 60 * 1000;
      setStartDate(lastWeek);
      setEndDate(currentDate);
      setIsCustomDate(false);
    } else if (value === "last15Days") {
      // getting the date of last 15 days
      const last15Days = currentDate - 15 * 24 * 60 * 60 * 1000;
      setStartDate(last15Days);
      setEndDate(currentDate);
      setIsCustomDate(false);
    } else if (value === "last30Days") {
      // getting the date of last 30 days
      const last30Days = currentDate - 30 * 24 * 60 * 60 * 1000;
      setStartDate(last30Days);
      setEndDate(currentDate);
      setIsCustomDate(false);
    } else {
      setStartDate(null);
      setEndDate(currentDate);
      setIsCustomDate(false);
    }
  };

  const handleScoreRangeChange = (e) => {
    const value = e.target.value;
    if (value === "custom") {
      setIsCustomScore(true);
    } else {
      setIsCustomScore(false);
    }
  };

  const handleExperinceRangeChange = (e) => {
    const value = e.target.value;
    if (value === "custom") {
      setIsCustomExperince(true);
    } else {
      setIsCustomExperince(false);
    }
  };

  const handleExport = async () => {
    const payload = {
      // assessmentType,
      statusFilter,
      minScore,
      maxScore,
      startDate,
      endDate,
    };
    // onExport(payload);

    console.log(payload);
    console.log("this is the view", selectedExport);

    const response = await apiPostPut(
      payload,
      `/company-dashboard/co
      mpany-applicants-data/${"678a787a25a2080742c2a8f7"}`,
      "POST"
    );
    console.log(response);
  };

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="max-w-3xl mx-auto p-12 bg-white rounded-lg shadow-md relative">
            <div className="flex items-baseline">
              <button
                onClick={() => onClose()}
                className="absolute top-2 right-2 text-gray-500"
              >
                &times;
              </button>
              <div className="flex top-3  bg-primary2 border w-10 h-10 rounded-3xl justify-center items-center relative">
                <AiOutlineDownload className="" />
              </div>
              <h2 className="text-lg font-bold  ml-4">Export Resumes</h2>
            </div>
            <p className="text-sm text-gray-500 mb-3 -mt-2 ml-14 absolute ">
              Select Resumes
            </p>

            {/* <div className="mb-10">
              <label className="block text-sm font-semibold mb-2 mt-10">
                Select assessment
              </label>
              <select
                value={selectedResumes}
                onChange={(e) => {
                  onSelectResumes(e.target.value);
                }}
                className="w-full border border-gray-300 text-primary  rounded-lg p-2"
              >
                <option className="text-gray-500" value="">
                  All Resumes
                </option>
                <option className="text-gray-500" value="Uidesigners">
                  Ui designers
                </option>
                <option className="text-gray-500" value="ReactDevelopers">
                  React Developers
                </option>
                {resumes.map((resume) => (
                  <option key={resume.id} value={resume.id}>
                    {resume.name}
                  </option>
                ))}
              </select>
            </div> */}
            {/* <div className="mb-10">
              <label className="block text-sm font-semibold mb-2">
                Assessment Type
              </label>
              <select
                value={assessmentType}
                onChange={(e) => setAssessmentType(e.target.value)}
                className="w-full border border-gray-300 text-primary rounded-lg p-2"
              >
                <option value="all">All</option>
                <option value="mockTest">Mock Test</option>
                <option value="interview">Interview</option>
                <option value="jobPost">Job Post</option>
                <option value="resumeSorting">Resume Sorting</option>
              </select>
            </div> */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-semibold mb-2 mt-4 ">
                  Date Range
                </label>
                <select
                  value={selectedAssessment}
                  onChange={onSelectAssessment}
                  className="w-full border border-gray-300 text-primary  rounded-lg p-2"
                  onClick={(e) => handleDateRangeChange(e)}
                >
                  <option className="text-gray-500" value="all">
                    All dates
                  </option>
                  <option className="text-gray-500" value="lastWeek">
                    last week
                  </option>
                  <option className="text-gray-500" value="last15Days">
                    last 15 days
                  </option>
                  <option className="text-gray-500" value="last30Days">
                    last 30 days
                  </option>
                  <option className="text-gray-500" value="custom">
                    custom dates
                  </option>
                </select>

                {isCustomDate && (
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div>
                      <label className="block text-xs font-normal mt-4">
                        Start date
                      </label>
                      <input
                        type="date"
                        onChange={(e) =>
                          setStartDate(new Date(e.target.value).getTime())
                        }
                        className="w-full border border-gray-300 text-sm rounded-lg p-1"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-normal mt-4">
                        End date
                      </label>
                      <input
                        type="date"
                        onChange={(e) =>
                          setEndDate(new Date(e.target.value).getTime())
                        }
                        className="w-full border border-gray-300 text-sm rounded-lg p-1"
                      />
                    </div>
                  </div>
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold  mb-2 mt-4">
                  Score Range
                </label>
                <select
                  value={selectedAssessment}
                  onChange={onSelectAssessment}
                  className="w-full border border-gray-300 text-primary rounded-lg p-2"
                  onClick={(e) => handleScoreRangeChange(e)}
                >
                  <option className="text-gray-500" value="">
                    All scores
                  </option>
                  <option className="text-gray-500" value="above90">
                    Above 90%
                  </option>
                  <option className="text-gray-500" value="70-89">
                    70-89%
                  </option>
                  <option className="text-gray-500" value="below70">
                    less than 70%
                  </option>
                  <option className="text-gray-500" value="custom">
                    custom score
                  </option>
                </select>

                {isCustomScore && (
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div>
                      <label className="block text-xs font-normal mt-4">
                        Minimum score (%)
                      </label>
                      <input
                        type="number"
                        onChange={(e) => setMinScore(e.target.value)}
                        className="w-full border border-gray-300 text-sm rounded-lg p-1"
                        placeholder="Minimum score"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-normal  mt-4">
                        Maximum score (%)
                      </label>
                      <input
                        type="number"
                        onChange={(e) => setMaxScore(e.target.value)}
                        className="w-full border border-gray-300 text-sm rounded-lg p-1"
                        placeholder="Maximum score"
                      />
                    </div>
                  </div>
                )}
                <div className="grid grid-cols-2 gap-0 -ml-80 mb-6">
                  <div>
                    <label className="block text-sm font-semibold mt-4">
                      Experince Range
                    </label>
                    <select
                      value={selectedAssessment}
                      onChange={onSelectAssessment}
                      className="w-full border border-gray-300 text-primary rounded-lg p-2"
                      onClick={(e) => handleExperinceRangeChange(e)}
                    >
                      <option className="text-gray-500" value="">
                        All Experince
                      </option>
                      <option className="text-gray-500" value="1 to 2 years">
                        1 to 2 years
                      </option>
                      <option className="text-gray-500" value="2 to 5 years">
                        2 to 5 years
                      </option>
                      <option className="text-gray-500" value="5 to 10 years">
                        5 to 10 years
                      </option>
                      <option className="text-gray-500" value="custom">
                        custom score
                      </option>
                    </select>
                    {isCustomExperince && (
                      <div className="grid grid-cols-2 gap-4 mb-6">
                        <div>
                          <label className="block text-xs font-normal mt-4">
                            Minimum Experince
                          </label>
                          <input
                            type="number"
                            onChange={(e) => setMinScore(e.target.value)}
                            className="w-full border border-gray-300 text-sm rounded-lg p-1"
                            placeholder="Minimum Experince"
                          />
                        </div>
                        <div>
                          <label className="block text-xs font-normal  mt-4">
                            Maximum Experince
                          </label>
                          <input
                            type="number"
                            onChange={(e) => setMaxScore(e.target.value)}
                            className="w-full border border-gray-300 text-sm rounded-lg p-1"
                            placeholder="Maximum Experince"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mb-6">
                <label className="block text-2xl font-normal mb-4">
                  Select Export Format
                </label>

                <div className="flex items-center justify-between ">
                  {ExportFormat.map((format) => (
                    <div
                      key={format.id}
                      className={`flex items-center  ${
                        currentTab === format.id
                          ? "border border-primary"
                          : "border border-gray-500"
                      } px-5 min-w-[10vw] py-2 rounded-lg justify-between  relative`}
                    >
                      <span className="text-sm">{format.name}</span>

                      <input
                        type="radio"
                        name="exportFormat"
                        checked={currentTab === format.id}
                        onChange={() => {
                          format.action();
                          console.log(format.name);
                          setSelectedExport(format.name);
                        }}
                        className="peer h-3 w-3 cursor-pointer appearance-none rounded-full border border-slate-300 checked:border-primary"
                      />

                      <div className="absolute  bg-primary w-2 h-2 rounded-full opacity-0 peer-checked:opacity-100 top-1/2 right-[1.123em] transform -translate-x-1/2 -translate-y-1/2"></div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="text-right">
                <button
                  onClick={handleExport}
                  className="bg-orange-500 mr-72 text-black py-2 px-6 rounded-lg justify-center  items-center"
                >
                  Export
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExportDataUI3;
